import { Injectable, Injector } from '@angular/core';
import { Overlay } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { ConfirmDialogComponent } from '@shared/component/confirm-dialog/confirm-dialog.component';

@Injectable({ providedIn: 'root' })
export class ConfirmService {
  constructor(private overlay: Overlay, private injector: Injector) {}

  open(title: string, message: string, onConfirm: () => void, onCancel?: () => void) {
    const overlayRef = this.overlay.create({
      hasBackdrop: true,
      backdropClass: 'dialog-backdrop',
      positionStrategy: this.overlay.position()
        .global()
        .centerHorizontally()
        .centerVertically(),
      scrollStrategy: this.overlay.scrollStrategies.block()
    });

    const dialogPortal = new ComponentPortal(ConfirmDialogComponent);
    const dialogRef = overlayRef.attach(dialogPortal);

    dialogRef.instance.title = title;
    dialogRef.instance.message = message;

    dialogRef.instance.confirm.subscribe(() => {
      overlayRef.dispose();
      onConfirm();
    });

    dialogRef.instance.cancel.subscribe(() => {
      overlayRef.dispose();
      onCancel && onCancel();
    });

    overlayRef.backdropClick().subscribe(() => overlayRef.dispose());
  }
}
